import { render, staticRenderFns } from "./ResetInitiate.vue?vue&type=template&id=42121b62&"
import script from "./ResetInitiate.vue?vue&type=script&lang=js&"
export * from "./ResetInitiate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports